// extracted by mini-css-extract-plugin
export default {"startAdornment":"PurchaseOrderInfoForm_startAdornment__FZRrC"};